var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.products)?_c('div',{staticClass:"recently-viewed"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h2',[_vm._v(_vm._s(_vm.$t('recently_viewed')))])]),_vm._l((_vm.products),function(item){return _c('div',{key:item.id,staticClass:"col-lg-3 col-md-4"},[_c('Product',{attrs:{"product":item}})],1)})],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }